import { render, staticRenderFns } from "./BaseFileViewer.vue?vue&type=template&id=3f7316da&scoped=true&"
import script from "./BaseFileViewer.vue?vue&type=script&lang=js&"
export * from "./BaseFileViewer.vue?vue&type=script&lang=js&"
import style0 from "./BaseFileViewer.vue?vue&type=style&index=0&id=3f7316da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7316da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDialog,VIcon,VSheet,VSpacer,VTooltip})
